﻿(() => {
  const checkoutSelector = '#checkout, #CartDrawer-Checkout';
  const messageSelector = '[data-incomplete-bundle-message]';
  const bundlePropertyName = String.fromCharCode(1053, 1072, 1073, 1110, 1088);
  let checkTimer;

  function checkCart(cart) {
    const bundleLines = new Map();
    const alternatePropertyName = '\u0420\u045a\u0420\u00b0\u0420\u00b1\u0421\u2013\u0421\u201e';

    (cart.items || []).forEach((item) => {
      const properties = item.properties || {};
      const bundleName = properties[bundlePropertyName] || properties[alternatePropertyName];
      if (typeof bundleName !== 'string' || !bundleName.trim()) return;

      const name = bundleName.trim();
      const lines = bundleLines.get(name) || [];
      lines.push(item);
      bundleLines.set(name, lines);
    });

    const hasIncompleteBundle = Array.from(bundleLines.values()).some((lines) =>
      lines.length === 1 && Number(lines[0].quantity) === 1
    );
    const hasVisibleCartItems = (cart.items || []).some((item) =>
      (item.properties || {})._auto_bundle_managed !== '1'
    );

    document.querySelectorAll(checkoutSelector).forEach((button) => {
      button.dataset.incompleteBundle = hasIncompleteBundle ? 'true' : 'false';
      if (hasIncompleteBundle || !hasVisibleCartItems) {
        button.disabled = true;
      } else if (window.NP?.selectorCheckoutButton && button.matches(window.NP.selectorCheckoutButton) && window.NP.checkoutDisabled) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
    });

    document.querySelectorAll(messageSelector).forEach((message) => {
      message.hidden = !hasIncompleteBundle;
    });
  }

  function refreshCartCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(() => {
      fetch('/cart.js')
        .then((response) => response.json())
        .then(checkCart)
        .catch((error) => console.error('Could not check bundle completeness:', error));
    }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartCheck, { once: true });
  } else {
    refreshCartCheck();
  }

  document.addEventListener('cart:updated', refreshCartCheck);
  document.addEventListener('cart:refresh', refreshCartCheck);
  document.addEventListener('change', (event) => {
    if (event.target.matches('cart-items .quantity__input, cart-drawer-items .quantity__input, input[name="updates[]"]')) {
      refreshCartCheck();
    }
  });

  new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) =>
      node.nodeType === 1 && (node.matches(checkoutSelector) || node.querySelector(checkoutSelector))
    ))) {
      refreshCartCheck();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  const originalFetch = window.fetch.bind(window);
  window.fetch = (...args) => {
    const input = args[0];
    const init = args[1] || {};
    const url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
    const method = String(init.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const cartMutation = url.origin === window.location.origin && method !== 'GET' &&
      /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);

    return originalFetch(...args).then((response) => {
      if (cartMutation) refreshCartCheck();
      return response;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(checkoutSelector);
    if (button?.dataset.incompleteBundle === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.submitter?.matches(checkoutSelector) && event.submitter.dataset.incompleteBundle === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
